import { Button, Checkbox, Divider, Form, Input, message } from "antd";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import axios from "../../config/axios";
import GoogleLoginButton from "../GoogleLoginButton/GoogleLoginButton";
import styles from "./AuthModal.module.scss";

const SignInForm = ({ onSuccess, onSwitchToRegister, onClose }) => {
    const navigate = useNavigate();
    const { setUser, setIsAuthenticated } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const signInUser = async (values) => {
        try {
            setLoading(true);
            const response = await axios.post(`/users/login`, values);

            if (response.data.err === true) {
                message.error(response.data.msg || "Please verify your email address to login!");
                return;
            }

            localStorage.setItem("device_id", response.data.access_token);
            let userData = response.data.user;
            userData.wishlist = !userData.wishlist ? [] : userData.wishlist;

            setIsAuthenticated(true);
            setUser(userData);
            message.success("Successfully logged in!");
            onSuccess?.(response.data);
        } catch (error) {
            message.error(error.response?.data?.msg || "Invalid credentials! try again.");
        } finally {
            setLoading(false);
        }
    };

    const goToForgotPassword = () => {
        onClose?.();
        navigate("/forgot-password");
    };

    return (
        <div className={styles.auth_body}>
            <h2 className={styles.auth_heading}>Welcome Back!</h2>
            <h3 className={styles.auth_subheading}>Login</h3>

            <Form
                name="signin"
                initialValues={{ remember: true }}
                onFinish={signInUser}
                scrollToFirstError
                layout="vertical"
                requiredMark={false}
                labelCol={{ style: { fontWeight: 500 } }}
                className={styles.auth_form}
            >
                <Form.Item
                    name="email"
                    label="E-mail"
                    rules={[
                        { type: "email", message: "The input is not valid Email!" },
                        { required: true, message: "Please input your email address!" },
                    ]}
                >
                    <Input size="large" />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: "Please input your password!" }]}
                >
                    <Input.Password size="large" placeholder="8+ characters required" />
                </Form.Item>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                        <Checkbox style={{ color: "var(--color-dark)" }}>Remember me</Checkbox>
                    </Form.Item>
                    <button type="button" className={styles.forgot_link} onClick={goToForgotPassword}>
                        Forgot password?
                    </button>
                </div>

                <Form.Item className="mb-2" style={{ marginTop: "1.5rem" }}>
                    <Button
                        className={styles.submit_btn}
                        size="large"
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        disabled={loading}
                        block
                    >
                        Login Now
                    </Button>

                    <span className={styles.switch_line}>
                        Don't have an account?{" "}
                        <button type="button" className={styles.switch_button} onClick={onSwitchToRegister}>
                            Sign Up
                        </button>
                    </span>
                </Form.Item>
            </Form>

            <Divider className="my-0">
                <span className={styles.divider_label}>OR</span>
            </Divider>

            <div className={styles.social_row}>
                <GoogleLoginButton onSuccess={onSuccess} text="signin_with" />
            </div>
        </div>
    );
};

export default SignInForm;
